import type { CardDisplayOptionType } from '../model/types/productCard';
import type { ProductCardType } from '@shared/types/product';

import { CardVariant } from './CardVariant/CardVariant';
import { RowVariant } from './RowVariant/RowVariant';

export type ProductCardProps = {
  view: CardDisplayOptionType;
  data: ProductCardType;
  comparisonPage?: boolean;
};

export const ProductCard = ({ view = 'grid', data, comparisonPage }: ProductCardProps) => {
  if (view === 'row') {
    return <RowVariant data={data} />;
  }

  return (
    <CardVariant
      comparisonPage={comparisonPage}
      data={data}
    />
  );
};
